import { Checkbox } from 'primereact/checkbox';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { SelectButton } from 'primereact/selectbutton';
import React, { Component } from 'react';
import EditableDropdown from './EditableDropdown';
import { ColorSelect } from './ColorSelect';
import { MultiSelect } from 'primereact/multiselect';

export class Form extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state={formData:{...props.formData}};
    }
    componentDidUpdate=(prevfield,prevState)=>{
        //console.log("Form:componentDidUpdate");
        if(prevfield.formData!=this.props.formData)
            this.setState({formData:{...this.props.formData}});
    }
    onValChange=(e)=>
	{
        //console.log("onValChange:"+e.target.id+":"+e.target.value);//+" e="+JSON.stringify(e.target));
		var value = this.state.formData;
        if(e.target.type=="checkbox")
		    value[e.target.id]=e.target.checked;
        else
		    value[e.target.id]=e.target.value;
        //console.log("onValChang2e:"+JSON.stringify(value));

        this.setState({formData:value});
        //this.setState({formData:{tch:{},crs:{code:'AAA',name:'aAA',grade:'aa'}}});
        if(this.props.onChange)
            this.props.onChange(this.state.formData);
	}
    render()
    {
            var disabled=false;
            if(this.props.disabled)
                disabled=this.props.disabled;
            var className="field";
            if(this.props.ftype=='checkbox')
                className="field-checkbox";
            if(this.props.columns==2)
                className+=" col-6";
            else if(this.props.columns==3)
                className+=" col-4";
            else if(this.props.columns==4)
                className+=" col-3";
            else
                className+=" col-12";

            return(
            <div className={"formgrid grid"+((this.props.visible==undefined || this.props.visible==true)?"":" hidden")}>
                    {this.props.fields.map((field) =>{
                        const fld=field;
                        return (<Field key={field.id} formData={this.state.formData} field={fld} onValChange={this.onValChange} className={className} formDisabled={disabled}/>);
                    }
                    )}        
            </div>
        );
    }
};

export function Field({formData,field,onValChange,className,formDisabled})
{
    let fieldHTML;
    //console.log("field="+JSON.stringify(field));
    //console.log("formData="+JSON.stringify(formData));
    //console.log("formData[field]="+JSON.stringify(formData[field.field]));

    if(field.hidden)
        className=className+' hidden';

    if(field.ftype=='text')
    {
        if(formDisabled)
            fieldHTML=( 
                <div className={className}>
                <label>{field.label}</label>
                <div className="font-bold">{formData[field.field]}</div>
                </div>
            );
        else
            fieldHTML=(
            <div className={className}>
                <label htmlFor={field.id}>{field.label}</label>
                <InputText inputId={field.id} id={field.id} type="text" className="w-full" value={formData[field.field]} 
                    onChange={(e)=>onValChange(e)} disabled={field.disabled}></InputText>
            </div>
            );
    }
    else if(field.ftype=='number')
    {
        var step=field.step!=undefined?1:field.step;
        if(formDisabled)
            fieldHTML=( 
                <div className={className}>
                <label>{field.label}</label>
                <div className="font-bold">{formData[field.field]}</div>
                </div>
            );
        else
            fieldHTML=(
                <div className={className}>
                    <label htmlFor={field.id}>{field.label}</label>
                    <InputText inputId={field.id} id={field.id} type="number" step={step} className="w-full" value={formData[field.field]} 
                        onChange={(e)=>onValChange(e)} min={field.min} max={field.max} disabled={field.disabled}></InputText>
                </div>
                );
    }
    else if(field.ftype=='dropdown' && field.onAdd)
    {
        if(formDisabled)
            fieldHTML=( 
                <div className={className}>
                <label>{field.label}</label>
                <div className="font-bold">{formData[field.field]}</div>
                </div>
            );
        else
            fieldHTML=(
                <div className={className}>
                <label htmlFor={field.id}>{field.label}</label>
                <EditableDropdown inputId={field.id} id={field.id} value={formData[field.field]} 
                    options={field.options} className="w-full" onChange={(e)=>onValChange(e)} 
                    optionLabel={field.optionLabel} //prime bug option label should be set
                    optionValue={field.optionValue}
                    valueTemplate={field.valueTemplate} itemTemplate={field.itemTemplate}
                    onAdd={field.onAdd}>
                </EditableDropdown>
                </div>
            );
    }
    else if(field.ftype=='dropdown' && !field.onAdd)
    {
        if(formDisabled)
            fieldHTML=( 
                <div className={className}>
                <label>{field.label}</label>
                <div className="font-bold">{formData[field.field]}</div>
                </div>
            );
        else
            fieldHTML=(
                <div className={className}>
                <label htmlFor={field.id}>{field.label}</label>
                <Dropdown inputId={field.id} id={field.id} value={formData[field.field]} 
                    options={field.options} className="w-full" onChange={(e)=>onValChange(e)} 
                    optionLabel={field.optionLabel} //prime bug option label should be set
                    optionValue={field.optionValue} disabled={field.disabled} multiselect={field.multiSelect}
                        valueTemplate={field.valueTemplate} itemTemplate={field.itemTemplate}>                    
                </Dropdown>
                </div>
            );
    }    
    else if(field.ftype=='multiSelect')
    {
        if(formDisabled)
            fieldHTML=( 
                <div className={className}>
                <label>{field.label}</label>
                <div className="font-bold">{formData[field.field]}</div>
                </div>
            );
        else
            fieldHTML=(
                <div className={className}>
                <label htmlFor={field.id}>{field.label}</label>
                <MultiSelect inputId={field.id} id={field.id} value={formData[field.field]} 
                    options={field.options} className="w-full" onChange={(e)=>onValChange(e)} 
                    optionLabel={field.optionLabel} //prime bug option label should be set
                    optionValue={field.optionValue} disabled={field.disabled}
                        valueTemplate={field.valueTemplate} itemTemplate={field.itemTemplate}>                    
                </MultiSelect>
                </div>
            );
    }        
    else if(field.ftype=='color')
    {
        if(formDisabled)
            fieldHTML=( 
                <div className={className}>
                <label>{field.label}</label>
                <div className="font-bold">{formData[field.field]}</div>
                </div>
            );
        else
            fieldHTML=(
                <div className={className}>
                <ColorSelect className="w-full" inputId={field.id} id={field.id} options={field.options} value={formData[field.field]} onChange={(e)=>onValChange(e)} defaultColor="black"/>
                <label className="ml-3" htmlFor={field.id}>{field.label}</label>
                </div>
            );
    }        
    else if(field.ftype=='textarea')
    {
        if(formDisabled)
            fieldHTML=( 
                <div className={className}>
                <label>{field.label}</label>
                <div className="font-bold">{formData[field.field]}</div>
                </div>
            );
        else
            fieldHTML=(
                <div className={className}>
                    <label htmlFor={field.id}>{field.label}</label>
                    <InputTextarea inputId={field.id} id={field.id} className="w-full" value={formData[field.field]} onChange={(e)=>onValChange(e)}></InputTextarea>
                </div>
                );
    }
    else if(field.ftype=='code')
        {
            if(formDisabled)
                fieldHTML=( 
                    <div className={className}>
                    <label>{field.label}</label>
                    <div className="font-bold" style={{fontFamily: 'monospace, monospace'}}>{formData[field.field]}</div>
                    </div>
                );
            else
                fieldHTML=(
                    <div className={className}>
                        <label htmlFor={field.id}>{field.label}</label>
                        <InputTextarea inputId={field.id} rows="5" spellCheck="false" id={field.id} className="text-lg font-bold w-full" style={{fontFamily: 'monospace, monospace'}} defaultValue={formData[field.field]} onChange={(e)=>onValChange(e)}></InputTextarea>
                    </div>
                    );
        }    
    else if(field.ftype=='date')
    {
        if(formDisabled)
            fieldHTML=( 
                <div className={className}>
                <label>{field.label}</label>
                <div className="font-bold">{formData[field.field]}</div>
                </div>
            );
        else
            fieldHTML=(
                <div className={className}>
                    <label htmlFor={field.id}>{field.label}</label>
                    <InputText inputId={field.id} id={field.id} type="date" className="w-full" value={formData[field.field]} onChange={(e)=>onValChange(e)}></InputText>
                </div>
                );
    }
    else if(field.ftype=='checkbox')
    {
        var cbClass=" flex align-items-center";
        fieldHTML=(
            <div className={className+" formgroup-inline"}>            
            <div className={cbClass} key={field.id}>
                <input type="checkbox" inputId={field.id} id={field.id} checked={formData[field.field]} disabled={field.disabled}
                    onChange={(e)=>onValChange(e)}></input>
                <label htmlFor={field.id}>{field.label}</label>
            </div>
            </div>
            );
    }
    else if(field.ftype=='selectbutton')
    {
        const db=formDisabled?'true':'false';
        fieldHTML=(
            
            <div className={className}>
                <label htmlFor={field.id}>{field.label}</label>
                <SelectButton inputId={field.id} id={field.id} optionLabel={field.optionLabel} optionValue={field.optionValue} value={formData[field.field]} 
                    options={field.options} onChange={(e)=>onValChange(e)}></SelectButton>
            </div>
            );
    }

    //radio
    //time
    //console.log("fieldHTML="+JSON.stringify(fieldHTML));

    return(fieldHTML);
}

